import { connect } from 'react-redux'
import ScanInstructions from './ScanInstructions'
import getPremiumAppName from '../../../selectors/customer/getPremiumAppName'

const stateToProps = (state) => ({
  customerPremiumAppName: getPremiumAppName(state),
})

export default connect(stateToProps)(ScanInstructions)
